/* globals wNumb */

import { onAddressChangedEvent } from '../../Shared/React/js/components/addressSearch/AddressSearch';

(function () {
    'use strict';

    function main() {
        var page = wo$('#home-search-form');
        if (!page.length) return;

        var homeData = WhistleOut.readLookupData(page);

        var controller = {
            address: null,

            init: function () {
                WhistleOut.applySelectPicker(page.find('.selectpicker'));
                controller.bindByoButton();
                controller.bindControls();
                controller.bindSearch();
                controller.bindStateSelector();
                controller.bindAddress();
                controller.initDialog();

                WhistleOut.applySelectPickersStyle();
            },

            bindAddress: function () {
                // eslint-disable-next-line @typescript-eslint/no-this-alias
                var that = this;
                addEventListener(onAddressChangedEvent, function (event) {
                    that.address = event.detail.address;
                });
            },

            bindStateSelector: function () {
                try {
                    var $state = page.find('#state');
                    if ($state && $state.length > 0) {
                        WhistleOut.applySelectPicker($state);
                        if (typeof Cookies.get('state') !== 'undefined' && Cookies.get('state') !== null) {
                            $state.selectpicker('val', Cookies.get('state'));
                        }
                    }
                } catch (e) {
                    console.log('Error in bindStateSelector:', e);
                }
            },

            bindByoButton: function () {
                page.find('[data-show-byo-button]').each(function () {
                    var source = wo$(this);

                    WhistleOut.Tablets.bindByoPopover(
                        source,
                        homeData.byoPopoverTitle,
                        homeData.byoPopoverContent,
                        function (simType, simTypeName) {
                            controller.removeTablet(true, simType, simTypeName);
                        }
                    );
                });
            },

            bindControls: function () {
                var container = page.find('.search-line-1');
                WhistleOut.createSlider(
                    container.find('div[name="data-slider"]'),
                    container.find('span[name="data-text"]'),
                    homeData.dataSlider,
                    wNumb({ decimals: 0 })
                );
            },

            bindSearch: function () {
                // eslint-disable-next-line @typescript-eslint/no-this-alias
                var that = this;

                page.find('#search').on('click', function () {
                    if (
                        homeData.forceCurrentSupplier &&
                        page.find('select#currently-with').find(':selected').val() === ''
                    ) {
                        page.find('#current-supplier-error').show();
                        return;
                    }
                    page.find('#current-supplier-error').hide();

                    var config = WhistleOut.getSiteConfiguration();
                    if (
                        config.autoDetectLocation &&
                        (!that.address || !that.address.label || that.address.label.length === 0)
                    ) {
                        page.find('#search .fa-spinner').show();
                        WhistleOut.getCurrentLocation(
                            function (e) {
                                var address = e.label;
                                if (address.length > 1) {
                                    var siteCountry = (config.countryCode || '').toLowerCase();
                                    var clientCountry = (e.countryCode || '').toLowerCase();
                                    if (siteCountry === clientCountry) {
                                        that.address = { label: address };
                                    }
                                }
                                that.doSearch();
                            },
                            function () {
                                that.doSearch();
                            }
                        );
                    } else {
                        that.doSearch();
                    }
                });
            },

            doSearch: function () {
                page.find('#search .fa-spinner').show();

                var queryString = '';
                var criteria = homeData;
                var data = criteria.dataSlider.currentPeg.value;
                if (data) {
                    queryString = WhistleOut.appendQueryParam(queryString, 'data=' + data);
                }

                var tablet = criteria.tabletShortUrl;
                if (tablet) {
                    queryString = WhistleOut.appendQueryParam(queryString, 'tablet=' + tablet);
                }

                if (criteria.simOnly === true) {
                    queryString = WhistleOut.appendQueryParam(queryString, 'simonly=true');
                }

                if (criteria.simType && criteria.simType > 0) {
                    queryString = WhistleOut.appendQueryParam(queryString, 'simtype=' + criteria.simType);
                }

                if (criteria.defaultMaxTabletUpfront != null) {
                    queryString = WhistleOut.appendQueryParam(
                        queryString,
                        'maxupfront=' + criteria.defaultMaxTabletUpfront
                    );
                }

                var selectedNetworks = page.find('#network').val();
                if (selectedNetworks && selectedNetworks.length > 0) {
                    var network = selectedNetworks.join(',');

                    if (network && network.length > 0) {
                        queryString = WhistleOut.appendQueryParam(queryString, 'network=' + network);
                    }
                }

                if (this.address) {
                    queryString = WhistleOut.appendQueryParam(
                        queryString,
                        'address=' + this.address.label.replace(/\s+/g, '+')
                    );
                }

                var selectedCarrier = page.find('select#currently-with').find(':selected').data('short-url');
                if (selectedCarrier) {
                    queryString = WhistleOut.appendQueryParam(queryString, 'currentsupplier=' + selectedCarrier);
                }

                if (criteria.defaultTab != null && criteria.useDefaultTab) {
                    queryString = WhistleOut.appendQueryParam(queryString, 'tab=' + criteria.defaultTab);
                }

                var url = homeData.searchUrl + '?' + queryString;
                location.href = url;
            },

            tabletSelected: function (tabletData) {
                homeData.tabletShortUrl = tabletData.tabletShortUrl;
                homeData.allowTabletSub = tabletData.allowSub;
                if (tabletData.priceTypes && tabletData.priceTypes.length > 0) {
                    homeData.tabletPriceTypes = wo$.map(tabletData.priceTypes, function (value) {
                        return [value];
                    });
                } else {
                    homeData.tabletPriceTypes = [];
                }

                var container = page.find('.search-line-1');
                container.find('img[data-tablet-image]').attr('src', tabletData.tabletImage);
                container.find('img[data-tablet-large-image]').attr('src', tabletData.tabletLargeImage);
                container.find('img[data-tablet-image]').attr('alt', tabletData.tabletName);
                container.find('img[data-tablet-large-image]').attr('alt', tabletData.tabletName);
                container.find('a[data-tablet-image-link]').attr('href', tabletData.tabletExtraLargeImage);
                container.find('*[data-tablet-name]').text(tabletData.tabletName);
                container.find('*[data-optional-text]').addClass('hidden');

                container.find('a[data-tablet-specs-button]').each(function () {
                    wo$(this).data('tablet-specs-button', tabletData.tabletShortUrl);
                });

                WhistleOut.bindTabletSpecsModal(container);

                container.find('a[data-tablet-gallery-button]').each(function () {
                    wo$(this).data('tablet-gallery-button', tabletData.tabletShortUrl);
                });

                WhistleOut.bindTabletGallery(container);

                homeData.simType = null;
                container.find('*[data-sim-type-text]').text('');

                if (tabletData.tabletShortUrl) {
                    homeData.simOnly = false;
                    container.find('*[data-show-when-no-tablet]').addClass('hidden');
                    container.find('*[data-show-when-empty-tablet]').addClass('hidden');
                    container.find('*[data-show-when-empty-tablet-or-byo]').addClass('hidden');
                    container.find('*[data-show-when-tablet-selected]').removeClass('hidden');
                    container.find('*[data-tablet-name]').removeClass('hidden');
                    container.find('*[data-change-tablet]').removeClass('hidden');
                    homeData.useDefaultTab = !tabletData.hasPrepaidPlansOnly;
                } else {
                    homeData.simOnly = true;
                    homeData.useDefaultTab = true;
                    container.find('*[data-show-when-tablet-selected]').addClass('hidden');
                    container.find('*[data-show-when-empty-tablet]').addClass('hidden');
                    container.find('*[data-show-when-empty-tablet-or-byo]').addClass('hidden');
                    container.find('*[data-show-when-no-tablet]').removeClass('hidden');
                    container.find('*[data-tablet-name]').removeClass('hidden');
                    container.find('*[data-change-tablet]').removeClass('hidden');
                }
            },

            removeTablet: function (isByo, simType, simTypeName) {
                var modalData = {
                    tabletShortUrl: null,
                    tabletImage: null,
                    tabletName: null,
                    allowSub: false,
                    priceTypes: []
                };

                homeData.tabletShortUrl = modalData.tabletShortUrl;
                homeData.allowTabletSub = modalData.allowSub;
                homeData.tabletPriceTypes = modalData.priceTypes;
                homeData.simOnly = isByo === true;
                homeData.simType = simType;

                var container = page.find('.search-line-1');
                if (isByo === true) {
                    container
                        .find('img[data-tablet-image]')
                        .attr('src', container.find('img[data-tablet-image]').data('byo-tablet-image'));
                    container
                        .find('img[data-tablet-large-image]')
                        .attr('src', container.find('img[data-tablet-large-image]').data('byo-tablet-image'));

                    var simTypeText = '';
                    if (simTypeName && simTypeName.length > 0) {
                        simTypeText = '(' + simTypeName + ')';
                    }
                    container.find('*[data-tablet-name]').text(homeData.byoLabel);
                    container.find('*[data-sim-type-text]').text(simTypeText);
                    container.find('*[data-optional-text]').addClass('hidden');
                    container.find('*[data-price-types-values]').text('');

                    container.find('*[data-show-when-tablet-selected]').addClass('hidden');
                    container.find('*[data-show-when-empty-tablet]').addClass('hidden');
                    container.find('*[data-show-when-empty-tablet-or-byo]').removeClass('hidden');
                    container.find('*[data-show-when-no-tablet]').removeClass('hidden');
                    container.find('*[data-tablet-name]').removeClass('hidden');
                    container.find('*[data-change-tablet]').removeClass('hidden');
                    container.find('img[data-tablet-large-image]').attr('alt', homeData.byodSimOnly);
                } else {
                    container
                        .find('img[data-tablet-image]')
                        .attr('src', container.find('img[data-tablet-image]').data('add-tablet-image'));
                    container.find('img[data-tablet-image]').attr('alt', homeData.selectTabletmodel);
                    container
                        .find('img[data-tablet-large-image]')
                        .attr('src', container.find('img[data-tablet-large-image]').data('add-tablet-image'));
                    container.find('img[data-tablet-large-image]').attr('alt', homeData.selectTabletmodel);
                    container.find('*[data-tablet-name]').text(modalData.tabletName);
                    container.find('*[data-optional-text]').addClass('hidden');
                    container.find('*[data-price-types-values]').text('');
                    container.find('*[data-sim-type-text]').text('');

                    container.find('*[data-show-when-tablet-selected]').addClass('hidden');
                    container.find('*[data-show-when-empty-tablet]').removeClass('hidden');
                    container.find('*[data-show-when-empty-tablet-or-byo]').removeClass('hidden');
                    container.find('*[data-tablet-name]').addClass('hidden');
                    container.find('*[data-change-tablet]').addClass('hidden');
                }
            },

            initDialog: function () {
                page.find('*[data-show-tablet-modal]').each(function () {
                    wo$(this)
                        .off('click')
                        .click(function () {
                            WhistleOut.Tablets.showTabletPicker(false, function (selectedTablet) {
                                if (selectedTablet.id === -1) {
                                    controller.removeTablet(true, selectedTablet.simType, selectedTablet.simTypeName);
                                } else {
                                    var tabletData = {};
                                    tabletData.tabletShortUrl = selectedTablet.shortUrl;
                                    tabletData.allowSub = selectedTablet.similarTablets;
                                    tabletData.priceTypes = selectedTablet.priceTypes;
                                    tabletData.tabletImage = selectedTablet.imageUrl.medium;
                                    tabletData.tabletLargeImage = selectedTablet.imageUrl.large;
                                    tabletData.tabletExtraLargeImage = selectedTablet.imageUrl.extraLarge;
                                    tabletData.tabletOtherImageUrls = selectedTablet.otherImageUrls;
                                    tabletData.tabletName = selectedTablet.name;
                                    tabletData.hasPrepaidPlansOnly = selectedTablet.hasPrepaidPlansOnly;

                                    controller.tabletSelected(tabletData);
                                }
                            });
                        });
                });

                page.find('*[data-remove-tablet]').click(function () {
                    controller.removeTablet(false, null, null);
                });
            }
        };

        controller.init();
    }

    WhistleOut.initModule(import.meta.url, main);
})();
